import styled, {css} from "styled-components";

const Container = styled.div`
	display: flex;
	width: 100%;
	height: 100%;
	background-color: ${({ backrgroundColor }) => backrgroundColor ? backrgroundColor : 'black'};
	min-height: 100vh;
	cursor: ${({cursor}) => cursor && cursor};
	align-items: ${({align}) => align && align};
	justify-content: ${({justify}) => justify && justify};
	${({backgroundImage}) => backgroundImage && css`
		background-image: url(${backgroundImage});
		background-size: contain;
		background-position: center;
		background-repeat: no-repeat;
	`}
`;

export default Container;